export default {
  loggedIn: {
    deposit: '入金',
    withdraw: '出金',
    balance: '合計残高',
    cash: '現金',
    bonus: 'ボーナス',
    withdrawable: '出金可能額',
    transaction: '取引履歴',
    history: '履歴',
    myBet: 'My Bet',
    rollover: 'ロールオーバー',
    vault: '金庫',
    notification: '通知',
    affiliate: 'アフィリエイト - 月$5,000を稼ぐ',
    affiliateTitle: 'アフィリエイト',
    affiliateBadge: '月$5,000を稼ぐ',
    settings: '設定',
    currency: '通貨',
    language: '言語',
    liveSupport: 'ライブサポート',
    signOut: 'ログアウト'
  }
};
